if (!window.customElements.get("discount-countdown")) {
  var DiscountCountdown = class extends HTMLElement {
    constructor() {
      super();
      this._endingTime = this.getAttribute("data-ending-time");
      this._dateEl = this.querySelector("[data-countdown-day]");
      this._hourEl = this.querySelector("[data-countdown-hour]");
      this._minuteEl = this.querySelector("[data-countdown-minute]");
      this._secondsEl = this.querySelector("[data-countdown-seconds]");
      this._countdownIntervalFunction = this._handleCountdown.bind(this);
    }

    connectedCallback() {
      this._interval = setInterval(this._countdownIntervalFunction, 1000);
    }

    disconnectedCallback() {
      clearInterval(this._interval);
    }

    _formatNumber(num) {
      const str = num < 10 ? `0${num}` : String(num);
      return str
        .split('')
        .map(char => `<span>${char}</span>`)
        .join('');
    }

    _handleCountdown() {
      const targetTime = new Date(this._endingTime).getTime();
      const currentTime = new Date().getTime();
      const diffTime = targetTime - currentTime;

      if (diffTime <= 0) {
        this._dateEl.innerHTML = this._formatNumber(0);
        this._hourEl.innerHTML = this._formatNumber(0);
        this._minuteEl.innerHTML = this._formatNumber(0);
        this._secondsEl.innerHTML = this._formatNumber(0);
        return;
      }

      const day = Math.floor(diffTime / 86400000);
      const dayRemain = Math.floor(diffTime % 86400000);
      const hours = Math.floor(dayRemain / 3600000);
      const hoursRemain = Math.floor(dayRemain % 3600000);
      const minutes = Math.floor(hoursRemain / 60000);
      const minutesRemain = Math.floor(hoursRemain % 60000);
      const seconds = Math.floor(minutesRemain / 1000);

      this._dateEl.innerHTML = this._formatNumber(day);
      this._hourEl.innerHTML = this._formatNumber(hours);
      this._minuteEl.innerHTML = this._formatNumber(minutes);
      this._secondsEl.innerHTML = this._formatNumber(seconds);
    }
  };

  window.customElements.define("discount-countdown", DiscountCountdown);
}
